import { isEmpty } from '@rainbow-modules/validation';
import Ajv from 'ajv';
import {
    basicOperators,
    booleanOperators,
    numberOperators,
    textOperators,
} from 'pages/WebhooksV2Page/FiltersInput/FilterCondition/operators';

const operators = [
    ...basicOperators,
    ...booleanOperators,
    ...numberOperators,
    ...textOperators,
].map((operator) => operator.name);

const filtersSchema = {
    type: 'array',
    items: {
        type: 'array',
        items: {
            type: 'object',
            properties: {
                a: { type: 'string', minLength: 1, pattern: '^\\w+(?:\\.\\w+)+$' },
                o: { type: 'string', enum: operators },
                b: { type: ['string', 'null'] },
            },
            required: ['a', 'o'],
        },
        minLength: 1,
    },
};

const validateFilters = (value: unknown) => {
    if (Array.isArray(value)) {
        if (isEmpty(value)) return undefined;
        try {
            const ajv = new Ajv({ allErrors: true });
            const isValid = ajv.validate(filtersSchema, value);
            if (isValid) return undefined;
        } catch (error) {
            // no catch
        }
    }
    return 'Invalid Filters';
};

export default validateFilters;
